module.exports = __webpack_public_path__ + "static/media/img-goal-3.acc718d9.jpg";